import { InjectionKey, Ref } from "vue";
import ResourceTreeNodeDO = App.Data.ResourceTreeNodeDO;

export type ResourceTreeCategory = "requested_documents" | "dashboards";

export type FileBrowserAction =
	| "open-file"
	| "close"
	| "new-file"
	| "new-file-top"
	| "share-file"
	| "update-file-meta"
	| "update-file-definition"
	| "delete-file"
	| "toggle-is-favorite"
	| "new-folder"
	| "update-folder"
	| "delete-folder";

export type FolderNode = ResourceTreeNodeDO & {
	children: FolderNode[];
	disabled: boolean;
};

export const fileBrowserActionsKey: InjectionKey<Ref<FileBrowserAction[]>> =
	Symbol("fileBrowserActions");

export const isSharedWithMeNode = (node: ResourceTreeNodeDO | null): boolean =>
	!!node && node.parent_id === null;

export const isRootNode = (node: ResourceTreeNodeDO | null): boolean =>
	!!node && node.is_root_node && node.parent_id !== null;

/** Cache/render key: the synthetic shared node has no id to key on. */
export const folderKey = (node: ResourceTreeNodeDO): string =>
	isSharedWithMeNode(node) ? "shared-with-me" : `folder-${node.id}`;

export type FilterPatch = {
	from?: string | null;
	to?: string | null;
	userId?: number | null;
	tagIds?: number[] | null;
};

/** A date column's current range, as plain values for rendering. */
export type DateFilterRange = {
	from: string | null;
	to: string | null;
};
